import { render } from "./LawTable.vue?vue&type=template&id=48a6e990&scoped=true&ts=true"
import script from "./LawTable.ts?vue&type=script&lang=ts"
export * from "./LawTable.ts?vue&type=script&lang=ts"

import "./LawTable.scss?vue&type=style&index=0&id=48a6e990&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a6e990"]])

export default __exports__